import { Expose, Type } from "../../serialization/class-transformer/decorators";
import { LayoutDefinitionIdentity } from "./layout-definition.identity";

export class DraftLayoutInfoDto {
    @Expose()
    @Type(() => LayoutDefinitionIdentity)
    identity: LayoutDefinitionIdentity
}

